export default "__VITE_ASSET__CqJ1FZ5w__"